export default "__VITE_ASSET__BoFUscMp__"